export default String.raw`
.header-top-banner {
    padding: 16px 5%;
    
    &__text {
        font-weight: 400;
        width: 100%;
        text-align: center;
    }

    &__countdown-timer {
        letter-spacing: 1.8px;
    }

    &__content {
        &--links {
            > .cls-fix:not(:first-child) {
                display: none;
            }
            
            .header-top-banner__text-wrapper {
                flex: 1 0 auto;
            }
        }
    }

    &__link-wrapper {
        padding: unset;
        max-width: unset;
    }

    &__link {
        justify-content: center;
    }
}

.header-top-bar {
    justify-content: flex-end;
    padding: 8px 16px;
    &__side:first-child {
        display: none;
    }
    &__company-name {
        max-width: 130px;
    }
}

.header {
    &:not(.fixed) {
        border-bottom: 1px solid #E7E7E7;
    }
    &.sticky {
        position: static;
        top: unset;
        box-shadow: none;
        background-color: $bgColor;
    }
    &__main {
        padding: 8px 16px;
        &.closed {
            flex-direction: row-reverse;
            justify-content: flex-end;
            .header {
                &__logo {
                    flex-grow: 1;
                    display: flex;
                    justify-content: center;
                    a {
                        width: fit-content;
                    }
                }
                &__menu {
                    display: block;
                }
            }
            .header-nav__list > li:first-child .header-nav__btn {
                padding-left: 24px;
            }
        }
        &:not(.closed) {
            .header {
                &__logo {
                    padding-left: 0;
                }
                &__menu {
                    display: none;
                }
            }
            .header-client-area {
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: 999;
                width: 100vw;
                justify-content: space-between;
                background-color: #FFF;
                box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.12);
                padding: 0 5px;
                &__btn-wrapper {
                    &.mobile {
                        display: block;
                    }
                    &.start {
                        order: 0;
                    }
                    &.cart {
                        order: 1;
                    }
                    &.menu {
                        order: 2;
                    }
                    &.profile {
                        order: 3;
                    }
                    &.more {
                        order: 4;
                    }
                    &.wishlist {
                        order: 5;
                        display: none;
                    }
                    &.inquiry {
                        order: 6;
                        display: none;
                    }
                }
                &__btn {
                    padding: 8px 4px;
                    min-width: 66px;
                    width: 100%;
                    &-icon-wrapper {
                        margin-top: 0;
                    }
                    &-text {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        &.cart:not(.mobile) {
                            display: none;
                        }
                        &.mobile {
                            display: block;
                        }
                    }
                    &-price {
                        display: none;
                    }
                    .counter-bg {
                        top: -5px;
                    }
                }
                &__more-dropdown {
                    display: none;
                    position: absolute;
                    bottom: 60px;
                    right: 0;
                    background-color: #FFF;
                    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.12);
                    .header-client-area__btn {
                        flex-direction: row;
                        padding: 10px 16px;
                        max-height: none;
                        max-width: none;
                    }
                    .header-client-area__btn-text {
                        margin-left: 8px;
                    }
                }
            }
        }
    }
    &__search{
        &-input {
            &.hide-mobile-placeholder {
                &::placeholder {
                    opacity: 0;
                }
                &::-webkit-input-placeholder {
                    opacity: 0;
                }
        
                &:-moz-placeholder {
                    opacity: 0;
                }
        
                &::-moz-placeholder {
                    opacity: 0;
                }
        
                &:-ms-input-placeholder {
                    opacity: 0;
                }
            }
        }
        &:not(.header__categories-search) {
            grid-row: 1;
            grid-column: 2;
            margin: 8px 0 16px auto;
        }
    }
    &__autocomplete {
        width: calc(100vw - 32px);
        left: auto;
        right: 0;
    }

    .header-nav {
        display: none;
        &__list {
            flex-direction: column;
            align-items: flex-start;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(231, 231, 231, 0.91);
            & > li {
                width: 100%;
                &:first-child .header-nav__btn {
                    padding: 8px 24px;
                }
            }
        }
        &__btn {
            padding: 8px 24px;
            justify-content: space-between;
            font-weight: 500;
            &:hover {
                border-color: transparent;
            }
            &-icon {
                display: none;
            }
            &::after, &::before {
                display: none;
            }
        }
        &__mobile-icon {
            display: block;
            transform: rotate(-90deg);
            padding: 4px;
        }
    }

    .header-menu {
        &__content {
            border-top: 1px solid rgba(231, 231, 231, 0.91);
            max-width: 100%;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            width: 344px;
            overflow-y: auto;
        }
        &__contact {
            padding: 16px 24px 8px;
        }
        &__item {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: $primaryColorFont;
            margin-bottom: 4px;
            svg {
                margin-right: 8px;
            }
            &.text {
                font-weight: 400;
            }
            &.supervisor {
                @include body-1-semi-bold;
                cursor: pointer;
            }
        }
        &__box-supervisor {
            margin-top: 16px;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
    }
}

.header-cart {
    &__content {
        width: 344px;
    }
    &__name-text {
        font-size: 16px;
    }
    &__list-row {
        justify-content: space-between;
        &.first {
            .header-cart__list-column.quantity, .header-cart__list-column.price {
                display: none;
            }
        }
        &:not(.first) {
            display: grid;
            grid-template-columns: repeat(4, auto);
            grid-template-rows: auto auto;
        }
    }
    &__list-column {
        padding-right: 5px;
        &.mobile-link {
            display: block;
            grid-row: 1;
            grid-column: 2 / 4;
            margin-bottom: 10px;
            max-width: 180px;
        }
        &.product {
            width: 60px;
            grid-row: 1 / 3;
            grid-column: 1;
            span {
                display: none;
            }
        }
        &.quantity-col {
            width: 105px;
            grid-row: 2;
            grid-column: 2;
        }
        &.price {
            width: 80px;
            grid-row: 2;
            grid-column: 3;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
        &.delete {
            grid-row: 1 / 3;
            grid-column: 4;
        }
    }
    &__quantity {
        max-width: 65px;
        input {
            max-width: none;
        }
        button {
            display: none;
        }
    }
    &__column-text.mobile {
        display: block;
        font-weight: 500;
    }
    &__summary {
        flex-direction: column;
        &-column {
            width: 100%;
            &:first-child {
                margin-bottom: 16px;
            }
        }
        &-btn {
            margin-bottom: 0;
        }
    }
    &__empty-text {
        width: 80%;
    }
}

.header__sidebar-content.right {
    right: auto;
    left: 0;
    &.hide {
        transform: translateX(-100%);
    }
}
`